import { constant } from "../utils";

const falseFunction = Object.freeze(constant(false));

function naturalSort(...keys) {
  const keysCount = (keys = [...keys]).length;

  function __sort__($a, $b, keyIndex = 0) {
    if (keyIndex === keysCount) return 0;

    try {
      const key = keys[keyIndex];
      let a = $a[key];
      let b = $b[key];

      if (!(typeof a === 'number' || typeof b === 'number')) {
        a = String(a).toLowerCase();
        b = String(b).toLowerCase();
      }

      return a > b ? 1 : a < b ? -1 : __sort__($a, $b, ++keyIndex);
    } catch (e) { return -1 }
  }

  return function __sortFn__(a, b) {
    return __sort__(a, b, 0);
  }
}

export {
  falseFunction,
  naturalSort
}
